import Vue from 'vue';
import VueI18n, { type LocaleMessages } from 'vue-i18n';
import { bugsnag } from '@/services/bugsnag';

Vue.use(VueI18n);

type MessageSchema = Record<string, unknown>;
type Messages = Record<string, MessageSchema>;

function loadLocaleMessages(): Messages {
    const locales = import.meta.glob<{ default: MessageSchema }>(
        '@/lang/**/*.json',
        { eager: true },
    );

    const messages: Messages = {};

    Object.keys(locales).forEach((path) => {
        const matched = path.match(/([A-Za-z0-9-_]+)\.json$/i);

        if (matched?.[1]) {
            messages[matched[1]] = locales[path].default;
        }
    });

    return messages;
}

const i18n = new VueI18n({
    locale:         import.meta.env.VITE_APP_I18N_LOCALE ?? 'en',
    fallbackLocale: import.meta.env.VITE_APP_I18N_FALLBACK_LOCALE ?? 'en',
    messages:       loadLocaleMessages() as LocaleMessages,
    missing(locale: string, key: string) {
        const error = new Error(`i18n :: Key '${key}' not found for locale '${locale}'`);

        bugsnag.notify(error, (event) => {
            event.groupingHash = 'missingTranslation';
        });
    },
});

export default i18n;
